import axios from "axios";

export const submitFeedback = async (
  feedback: string,
  corrected_transcription: string,
  audioUuid: string,
) => {
  const body = {
    feedback: feedback,
    corrected_transcription: corrected_transcription,
  };
  const response = await axios.post(
    `${import.meta.env.VITE_API_URL}/${audioUuid}/feedback`,
    body,
  );
  return response.data;
};
